import {Button, Icon} from '@sollapay/ui/components';
import {cn} from '@sollapay/ui/lib';
import {useTranslation} from 'react-i18next';

import {useCopyToClipboard} from './useCopyToClipboard';

import type {FC} from 'react';

export interface CopyButtonProps {
  text: string;
  fieldName?: string;
  ns?: string;
}

export const CopyButton: FC<CopyButtonProps> = ({text, fieldName, ns = 'common'}) => {
  const {t} = useTranslation(ns);
  const {copy, copied} = useCopyToClipboard(ns);

  return (
    <Button
      variant="tertiary"
      size="icon-xs"
      onClick={() => copy(text, {fieldName})}
      aria-label={copied ? t('copied') : t('copy')}
      icon={<CopyStateIcon copied={copied} />}
    />
  );
};

export interface CopyStateIconProps {
  copied: boolean;
  className?: string;
}

/** The copy icon, swapped for a green check while the copied state lasts. */
export const CopyStateIcon: FC<CopyStateIconProps> = ({copied, className}) =>
  copied ? (
    <Icon name="check-circle" className={cn(className, 'text-indication-success')} />
  ) : (
    <Icon name="copy" className={className} />
  );
